import { Component, Input, OnInit, forwardRef } from '@angular/core';
import { AbstractControl, ControlValueAccessor, FormControl, FormGroup, NG_VALUE_ACCESSOR, Validators, NG_VALIDATORS, ValidatorFn } from '@angular/forms';

@Component({
  selector: 'app-text-box',
  templateUrl: './text-box.component.html',
  styleUrls: ['./text-box.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextBoxComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => TextBoxComponent),
      multi: true,
    }
  ]
})
export class TextBoxComponent implements OnInit, ControlValueAccessor {
  @Input() label: string;
  @Input() required: boolean;
  @Input() formControlName: string;
  @Input() type: string;
  @Input() frm: FormGroup;
  @Input() min?: number; // Input opcional para el valor mínimo
  @Input() max?: number; // Input opcional para el valor máximo
  @Input() pattern: string = "";

  showPassword: boolean = false;
  typeBox: string;
  modelo: any;

  public formControl: FormControl = new FormControl();

  constructor() {}

  ngOnInit(): void {
    this.typeBox = this.type;

    const control = this.frm.get(this.formControlName) as FormControl;

    if (control) {
      const validators: ValidatorFn[] = [];

      // Agregar el validador requerido si es necesario
      if (this.required) {
        validators.push(Validators.required);
      }

      if(this.type == "email")
      {
        validators.push(Validators.email);
      }

      if(this.pattern != "")
      {
        validators.push(Validators.pattern(this.pattern))
      }

      // Agregar validadores de longitud mínima y máxima si están definidos
      if (this.min !== undefined) {
        validators.push(Validators.minLength(this.min)); 
      }
      if (this.max !== undefined) {
        validators.push(Validators.maxLength(this.max)); 
      }

      // Asignar validadores solo si hay validadores
      if (validators.length > 0) {
        control.setValidators(validators);
        control.updateValueAndValidity(); // Actualizar el control con los nuevos validadores
      }
    }
  }

  onChange: any = () => { };
  onTouched: any = () => { };

  get value() {
    return this.modelo;
  }

  set value(val) {
    this.modelo = val;
    this.onChange(val);
    this.onTouched();
  }

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn) {
    this.onChange = fn;
  }

  registerOnTouched(fn) {
    this.onTouched = fn;
  }

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
    this.type = this.showPassword ? 'text' : 'password';
  }

  get ctrlInvalid() {
    return this.frm.controls[this.formControlName].invalid;
  }
  
  get ctrlTouched() {
    return this.frm.controls[this.formControlName].touched;
  }

  // Método para obtener el número de caracteres actuales del input
  get currentLength(): number {
    return this.modelo ? this.modelo.length : 0;
  }

  validate(control: AbstractControl): { [key: string]: any } | null {

    return null;
  }
}
